import JwtService from "@/services/jwt.service";

var _baseUrl = process.env.VUE_APP_API_BASE_URL;

//var _baseUrl = process.env.NODE_ENV === 'production' ? "https://www.romabravo.com/reservation/api/" : "https://localhost:44317/api/";
const AppConfig = {
  //baseUrl: "http://localhost:65202/api/",
  //baseUrl: "http://uat.jezreeldesigns.com/api/",
  baseUrl: _baseUrl,
};



export default AppConfig;

// export const headers = () => {
//   return {
//     "Content-Type": "application/json",
//     "Access-Control-Allow-Origin": "*",
//     "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
//   };
// };

/*'Access-Control-Allow-Credentials' 'true';
    add_header 'Access-Control-Allow-Headers' 'Content-Type'; 
    
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token, Authorization"*/
export const headers = () => {
  const token = JwtService.getToken();
  if (token == null || token.length == 0) {
    return {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      "Cache-Control": "no-cache"
    };
  }


  return {
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Access-Control-Expose-Headers":"*",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      "Cache-Control": "no-cache"
  };
};



export const apiVerbs = {
  get: "get",
  post: "post",
  put: "put",
  delete: "delete"
};

export const LocalStoreConstants = {
  quickLinks: "quickLinks.",
  cookiePolicy: "cookiePolicy.",
  shoppingCart: "cart.",
  ID_TOKEN_KEY: "",
  toastNotification: "toastNotification."
};